var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartingPointIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42115 11.2225V14.2488H2.25V2.74878H13.4567C13.508 2.74869 13.5585 2.76255 13.603 2.78896C13.6475 2.81537 13.6845 2.85341 13.7103 2.89927C13.7361 2.94513 13.7498 2.99719 13.75 3.05024C13.7502 3.10328 13.7369 3.15545 13.7114 3.20152L11.6192 6.98562L13.7114 10.7697C13.7369 10.8158 13.7502 10.868 13.75 10.921C13.7498 10.9741 13.7361 11.0261 13.7103 11.072C13.6845 11.1178 13.6475 11.1559 13.603 11.1823C13.5585 11.2087 13.508 11.2226 13.4567 11.2225H3.42115ZM3.42115 3.95931V10.0119H11.9436L10.27 6.98562L11.9436 3.95931H3.42115Z",
    fill: "url(#paint0_linear_443_46952)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_46952",
    x1: 8,
    y1: 14.2488,
    x2: 8,
    y2: 2.74878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28BEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1743FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartingPointIcon);
export default __webpack_public_path__ + "static/media/startingPointIcon.ec821dffa61a16d555a8b5d91e16caf9.svg";
export { ForwardRef as ReactComponent };